import React, { lazy } from "react";
import { ScreenKey } from "../../../permissions/screenKeys";

const ProportionalControllerCalculator = lazy(() => import("./proportional-controller-calculator"));
const RampLossCalculator = lazy(() => import("./ramp-loss-calculator"));
const Diagnostics = lazy(() => import("./diagnostics"));

// Offline calculators, grouped under their own root-level Tools menu and visible
// to every user (see ALWAYS_VISIBLE_SCREENS in permissions/screenKeys).
//
// Paths stay at two segments because ScreenPermissionGate derives the permission
// key from the first two path segments — a third segment would silently change
// which key is checked. The old /controls_admin/proportional_controller_tuning
// path is redirected in layout/routes.js.
const ToolsRoute = () => {
    const routes = [
        {
            key: "proportional_controller_calculator",
            path: `/${ScreenKey.PROPORTIONAL_CONTROLLER_CALCULATOR}`,
            component: <ProportionalControllerCalculator />,
        },
        {
            key: "ramp_loss_calculator",
            path: `/${ScreenKey.RAMP_LOSS_CALCULATOR}`,
            component: <RampLossCalculator />,
        },
        // LT-3348 — gated (LivelineControls), unlike the two calculators above.
        {
            key: "diagnostics",
            path: `/${ScreenKey.DIAGNOSTICS}`,
            component: <Diagnostics />,
        },
    ];

    return routes;
};

export default ToolsRoute;
